type NotificationsFilter = {
  limit: number;
  start: number;
  types?: string[];
};

const notificationsFilter: NotificationsFilter = {
  limit: 0,
  start: 0,
};

export type { NotificationsFilter };

export { notificationsFilter };
